<template>
  <div class="Child">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button type="primary" @click="clearRadioRowEevnt">
          取消选中
        </el-button>
        <el-button type="primary" @click="getRadioEvent">
          获取选中
        </el-button>
        <el-button type="primary" @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable1"
      height="500"
      border
      class="radio-table"
      :loading="loading"
      highlight-hover-row
      highlight-current-row
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="40" />
      <!-- <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="公司名称"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getShipperList, getShipperInfo } from "@/api/shipment";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        gmtCreatedRange: "",
        staffType: "1", // 类型(企业)
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        authStatus: 3,
        noTaxAdded: "1",
        branchCode: "lbb03"
      },
      Pagingconf: [],
      tableData: [],
      staffTypeOptions: [
        { value: 0, label: "个体托运人" },
        { value: 1, label: "企业" }
      ],

      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  computed: {
    ...mapState({
      shipment: state => state.user.shipment
    })
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable1.updateData();
    }
  },
  created() {},
  methods: {
    //查询代发托运人
    async shipmentlist() {
      this.loading = true;
      let response = "";
      response = await getShipperList(this.listQuery);
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      response.data.total > 10000
        ? (this.Pagingconf = [20, 30, 50, 100, 10000])
        : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      this.loading = false;
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    //获取选中
    getRadioEvent() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      getShipperInfo(this.getdata.code).then(response => {
        // 清理 data.areaList 数组中的 null
        response.data.areaList = response.data.areaList
          ? response.data.areaList.filter(value => value)
          : [];
        this.$emit("events", response.data);
      });
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    },
    // 翻译状态
    formatterStaffType({ cellValue }) {
      const item = this.staffTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
